import { savedSearchPayloadSchema } from './types'

import type {
	PrettyfiedSearchParams,
	SavedSearchPayload,
	SearchParams,
} from './types'

/**
 * Prettyfy the search params to make them more readable and smaller for Tanstack Query keys
 * @param params - The search params to prettyfy
 */
export const prettyfySearchParams = (
	params: Partial<SearchParams>,
): PrettyfiedSearchParams => {
	const { int, ...rest } = params

	// We use sets to deduplicate the integrations and events
	const integrations = new Set<string>()
	const events = new Set<string>()

	let defaultParams: PrettyfiedSearchParams = {
		...rest,
		integrations: [],
		events: [],
	}

	if (params.int) {
		params.int.map(({ id, ev }) => {
			integrations.add(id)
			events.add(ev)
		})
	}

	defaultParams = {
		...defaultParams,
		integrations: Array.from(integrations),
		events: Array.from(events),
	}

	return defaultParams
}

/**
 * Encode a v2 saved-search payload as a JSON string for the BE's opaque
 * `search_string` column. The `version: 2` discriminator lets us safely
 * ignore legacy v1 rows.
 */
export function encodeSavedSearch(payload: SavedSearchPayload): string {
	return JSON.stringify(payload)
}

/**
 * Decode a saved-search payload, returning null for legacy v1 rows and
 * malformed JSON. The route's saved-search list filters these nulls out.
 */
export function decodeSavedSearch(
	searchString: string,
): SavedSearchPayload | null {
	try {
		const parsed = JSON.parse(searchString)
		const result = savedSearchPayloadSchema.safeParse(parsed)
		return result.success ? result.data : null
	} catch {
		return null
	}
}
